import {
  AutoCompleteUncontrolled,
  ISelectType,
  useFetch,
  useNotificationContext,
  UsePrivileges,
} from "@4uhub/lib4uhub";
import { Box, Button, Stack, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ListService from "../../../../../services/list.service";
import { ListImportBatchService } from "../../../../../services/listImportBatch.service";

const translationPath = "page.4uDlist.listFiles.convertToList.";

const listService = new ListService();
const listImportBatchService = new ListImportBatchService();

export const AddToExistingList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { listImportBatchId } = useParams();
  const { setMessage } = useNotificationContext();
  const { privileges } = UsePrivileges();

  const [lists, setLists] = useState<ISelectType[]>([]);
  const [selectedList, setSelectedList] = useState<ISelectType | null>(null);

  const { sendRequest: getLists } = useFetch(listService.list);
  const { sendRequest: addToList, loading } = useFetch(
    listImportBatchService.addToExistingList
  );

  const allowed = privileges.some(
    (priv) =>
      priv.domainName === "all" || priv.domainName === "listimportbatchaddtolist"
  );

  const handleCancel = useCallback(() => navigate(-1), [navigate]);

  const handleConvert = useCallback(async () => {
    if (!selectedList || !listImportBatchId) return;

    const { success } = await addToList({
      listImportBatchId,
      listId: selectedList.id,
    });

    if (success) {
      setMessage({
        message: t(translationPath + "converted"),
        type: "success",
      });
      navigate(-1);
    }
  }, [addToList, listImportBatchId, navigate, selectedList, setMessage, t]);

  useEffect(() => {
    if (!allowed) {
      navigate("../..", { relative: "path", replace: true });
    }
  }, [allowed, navigate]);

  useEffect(() => {
    const fetchLists = async () => {
      const { data, success } = await getLists(null);
      if (data && success) {
        setLists(data);
      }
    };

    if (allowed) fetchLists();
  }, [allowed, getLists]);

  if (!allowed) return null;

  return (
    <Box sx={{ maxWidth: 560, mx: "auto", mt: 8, px: 2 }}>
      <Stack spacing={3}>
        <Typography variant="h5">
          {t(translationPath + "select_existing_list")}
        </Typography>
        <AutoCompleteUncontrolled
          label={t(translationPath + "select_list")}
          value={selectedList}
          onValueSelected={setSelectedList}
          options={lists}
          size="small"
          fullWidth
        />
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button fullWidth variant="outlined" onClick={handleCancel}>
            {t(translationPath + "cancel")}
          </Button>
          <Button
            fullWidth
            variant="contained"
            disabled={!selectedList || loading}
            onClick={handleConvert}
          >
            {t(translationPath + "convert")}
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default AddToExistingList;
